import React, { useState, useEffect } from "react";
import { ScrollShadowType } from "./type";

function isElementScrollable(ref: React.RefObject<HTMLDivElement>) {
  const { scrollHeight = 0, clientHeight = 0 } = ref.current || {};
  return scrollHeight > clientHeight;
}

function ScrollShadowComponent(props: ScrollShadowType) {
  const contentRef = React.useRef<HTMLDivElement>(null);
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const shadowTopRef = React.useRef<HTMLDivElement>(null);
  const shadowBottomRef = React.useRef<HTMLDivElement>(null);
  const [scrollApplicable, setScrollApplicable] = useState(false);

  useEffect(() => {
    if (isElementScrollable(contentRef)) {
      setScrollApplicable(true);
    }
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const contentScrollHeight = (contentRef.current?.scrollHeight ?? 0) - (wrapperRef?.current?.offsetHeight ?? 0);
      const scrollTop = contentRef.current?.scrollTop ?? 0;
      const newCurrentScroll = scrollTop / contentScrollHeight;

      if (shadowTopRef.current && shadowBottomRef.current) {
        shadowTopRef.current.style.opacity = newCurrentScroll.toString();
        shadowBottomRef.current.style.opacity = (1 - newCurrentScroll).toString();
      }
    };
    const contentElement = contentRef.current;
    if (scrollApplicable) {
      contentElement?.addEventListener("scroll", handleScroll);
    }
    return () => {
      contentElement?.removeEventListener("scroll", handleScroll);
    };
  }, [scrollApplicable]);

  return (
    <div className="wrapper" style={{ maxHeight: props.maxHeight }} ref={wrapperRef}>
      {scrollApplicable && <div className="shadow shadow--top" ref={shadowTopRef}></div>}
      <div className="content" ref={contentRef} style={{ maxHeight: props.maxHeight }}>
        {props.children}
      </div>
      {scrollApplicable && <div className="shadow shadow--bottom" ref={shadowBottomRef}></div>}
    </div>
  );
}

export default ScrollShadowComponent;
